import { NavigateFunction } from "react-router-dom";

export const onLogin = (navigate: NavigateFunction) => {
    navigate("/signin");
};

export const onLogout = (navigate: NavigateFunction) => {
    navigate("/logout");
};

export const onViewProfile = (navigate: NavigateFunction) => {

};

export const OnChangePassword = (navigate: NavigateFunction) => {

};